// Shared columns for Project Page Component Details & Create

/** Fields that support media upload (S3) on Project Page Component. Used by Upload File modal. */
export const PPC_MEDIA_UPLOAD_FIELDS = [
  {
    label: "Image Location 1",
    path: "content.imageLocation1",
    apiName: "Image_Location_1__c",
  },
  {
    label: "Image Location 2",
    path: "content.imageLocation2",
    apiName: "Image_Location_2__c",
  },
  {
    label: "Image Location 3",
    path: "content.imageLocation3",
    apiName: "Image_Location_3__c",
  },
];

export const PPC_PICKLIST_LABELS = {
  BUTTON_TYPE_1: "Button_Type__c",
  BUTTON_TYPE_2: "Button_Type_2__c",
  BUTTON_TYPE_3: "Button_Type_3__c",
};
export const recordTypeOptions = [
  {
    value: "2 Column 50-50",
    label: "2 Column 50-50",
  },
  {
    value: "2 Column Image Left 33-66",
    label: "2 Column Image Left 33-66",
  },
  {
    value: "2 Column Image Left 50-50",
    label: "2 Column Image Left 50-50",
  },
  {
    value: "2 Column Image Right 33-66",
    label: "2 Column Image Right 33-66",
  },
  {
    value: "2 Column Image Right 50-50",
    label: "2 Column Image Right 50-50",
  },
  {
    value: "3 Column 33-33-33",
    label: "3 Column 33-33-33",
  },
  {
    value: "Headline only",
    label: "Headline only",
  },
  {
    value: "Image Only",
    label: "Image Only",
  },
  { value: "Active Tasks", label: "Active Tasks" },
  {
    value: "Microsoft Project Page",
    label: "Microsoft Project Page",
  },
  {
    value: "Splash Page",
    label: "Splash Page",
  },
  {
    value: "Standalone Button",
    label: "Standalone Button",
  },
  {
    value: "Text Only Full Page",
    label: "Text Only Full Page",
  },
];
function buildButtonDependentFields(buttonType, button, prefix = "content.") {
  switch (buttonType) {
    case "Direct URL":
      return [
        {
          label: `Button Name ${button}`,
          path: `${prefix}buttonName${button}`,
          type: "text",
        },
        {
          label: `Button URL ${button}`,
          path: `${prefix}buttonUrl${button}`,
          type: "text",
        },
      ];
    case "File Download":
      return [
        {
          label: `Button Name ${button}`,
          path: `${prefix}buttonName${button}`,
          type: "text",
        },
        {
          label: `File Download URL ${button}`,
          path: `${prefix}fileUrl${button}`,
          type: "text",
        },
      ];
    case "Qualification URL":
      return [
        {
          label: `Button Name ${button}`,
          path: `${prefix}buttonName${button}`,
          type: "text",
        },
      ];
    default:
      return [];
  }
}

export function buildInfoFieldsForPpc({
  isEditing = false,
  data = null,
  form = null,
} = {}) {
  return [
    { label: "Name", path: "info.name", type: "text", readOnly: true },
    {
      label: "Project Page",
      path: isEditing ? "info.projectPageId" : undefined,
      type: isEditing ? "lookup" : "text",
      lookupObject: "ProjectPage",
      value:
        !isEditing && (form || data)?.info?.projectPageId
          ? `${
              (form || data)?.info?.projectPageName ||
              (form || data)?.info?.projectPageId
            }`
          : !isEditing
            ? (form || data)?.info?.projectPageName || "—"
            : undefined,
      valueLabel: isEditing
        ? (form || data)?.info?.projectPageName || ""
        : undefined,
      linkTo:
        !isEditing && (form || data)?.info?.projectPageId
          ? `/pp/${(form || data)?.info?.projectPageId}`
          : undefined,
    },
    {
      label: "Project Page Type",
      path: "info.projectPageType",
      type: "text",
      readOnly: true,
    },
    {
      label: "Project Name",
      path: "info.projectName",
      type: "text",
      readOnly: true,
    },
    {
      label: "Project Objective",
      path: "info.projectObjective",
      type: "text",
      readOnly: true,
    },
    {
      label: "Record Type",
      path: "info.recordTypeName",
      type: "select",
      options: recordTypeOptions,
    },
    { label: "Component Order", path: "info.componentOrder", type: "text" },
  ];
}

export function buildContentFieldsForPpc({ data = null, form = null } = {}) {
  const recordType = data?.info?.recordTypeName || form?.info?.recordTypeName;
  const buttonOneType =
    data?.content?.buttonType1 || form?.content?.buttonType1;
  const buttonTwoType =
    data?.content?.buttonType2 || form?.content?.buttonType2;
  const buttonThreeType =
    data?.content?.buttonType3 || form?.content?.buttonType3;
  switch (recordType) {
    case "2 Column 50-50":
      return [
        { label: "Headline 1", path: "content.headline1", type: "text" },
        { label: "Headline 2", path: "content.headline2", type: "text" },

        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
        {
          label: "Image-Video Location 2",
          path: "content.imageLocation2",
          type: "file",
        },

        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "textArea",
        },
        {
          label: "Text Area 2",
          path: "content.textArea2",
          type: "textArea",
        },
        {
          label: "Button Type 1",
          path: "content.buttonType1",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        ...buildButtonDependentFields(buttonOneType, 1),
        {
          label: "Button Type 2",
          path: "content.buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        ...buildButtonDependentFields(buttonTwoType, 2),
      ];
    case "2 Column Image Left 33-66":
      return [
        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
        {
          label: "Headline 2",
          path: "content.headline2",
          type: "text",
        },
        {
          label: "Text Area 2",
          path: "content.textArea2",
          type: "text",
        },
        {
          label: "Button Type 2",
          path: "content.buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        ...buildButtonDependentFields(buttonTwoType, 2),
      ];
    case "2 Column Image Left 50-50":
      return [
        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
        {
          label: "Headline 2",
          path: "content.headline2",
          type: "text",
        },
        {
          label: "Text Area 2",
          path: "content.textArea2",
          type: "text",
        },
        {
          label: "Button Type 2",
          path: "content.buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        ...buildButtonDependentFields(buttonTwoType, 2),
      ];
    case "2 Column Image Right 33-66":
      return [
        {
          label: "Headline 1",
          path: "content.headline1",
          type: "text",
        },
        {
          label: "Image-Video Location 2",
          path: "content.imageLocation2",
          type: "file",
        },
        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "text",
        },
        {
          label: "Button Type 1",
          path: "content.buttonType1",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        ...buildButtonDependentFields(buttonOneType, 1),
      ];
    case "2 Column Image Right 50-50":
      return [
        {
          label: "Headline 1",
          path: "content.headline1",
          type: "text",
        },
        {
          label: "Image-Video Location 2",
          path: "content.imageLocation2",
          type: "file",
        },
        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "text",
        },
        {
          label: "Button Type 1",
          path: "content.buttonType1",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        ...buildButtonDependentFields(buttonOneType, 1),
      ];
    case "3 Column 33-33-33":
      return [
        {
          label: "Headline 1",
          path: "content.headline1",
          type: "text",
        },
        {
          label: "Headline 2",
          path: "content.headline2",
          type: "text",
        },
        {
          label: "Headline 3",
          path: "content.headline3",
          type: "text",
        },
        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
        {
          label: "Image-Video Location 2",
          path: "content.imageLocation2",
          type: "file",
        },
        {
          label: "Image-Video Location 3",
          path: "content.imageLocation3",
          type: "file",
        },
        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "text",
        },
        {
          label: "Text Area 2",
          path: "content.textArea2",
          type: "text",
        },
        {
          label: "Text Area 3",
          path: "content.textArea3",
          type: "text",
        },
        {
          label: "Button Type 1",
          path: "content.buttonType1",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        ...buildButtonDependentFields(buttonOneType, 1),
        {
          label: "Button Type 2",
          path: "content.buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        ...buildButtonDependentFields(buttonTwoType, 2),
        {
          label: "Button Type 3",
          path: "content.buttonType3",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_3,
          required: true,
        },
        ...buildButtonDependentFields(buttonThreeType, 3),
      ];
    case "Active Tasks":
      return [
        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
        {
          label: "Headline 1",
          path: "content.headline1",
          type: "text",
        },
        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "text",
        },
        {
          label: "Headline 2",
          path: "content.headline2",
          type: "text",
        },
        {
          label: "Text Area 2",
          path: "content.textArea2",
          type: "text",
        },
      ];
    case "Splash Page":
      return [
        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
        {
          label: "Headline 1",
          path: "content.headline1",
          type: "text",
        },
        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "text",
        },
        {
          label: "Headline 2",
          path: "content.headline2",
          type: "text",
        },
        {
          label: "Text Area 2",
          path: "content.textArea2",
          type: "text",
        },
      ];
    case "Headline only":
      return [
        {
          label: "Headline 1",
          path: "content.headline1",
          type: "text",
        },
      ];
    case "Image Only":
      return [
        {
          label: "Image-Video Location 1",
          path: "content.imageLocation1",
          type: "file",
        },
      ];
    case "Standalone Button":
      return [
        {
          label: "Button Type 1",
          path: "content.buttonType1",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        ...buildButtonDependentFields(buttonOneType, 1),
      ];
    case "Text Only Full Page":
      return [
        {
          label: "Text Area 1",
          path: "content.textArea1",
          type: "text",
        },
      ];
    default:
      return [];
  }
}

export function buildSysFieldsForPpc() {
  return [
    {
      label: "CreatedById",
      path: "sys.createdById",
      type: "text",
      readOnly: true,
    },
    {
      label: "LastModifiedById",
      path: "sys.lastModifiedById",
      type: "text",
      readOnly: true,
    },
  ];
}

// Create modal fields
export function buildCreateFieldsForPpc(form) {
  return [
    {
      cols: 2,
      fields: [
        {
          label: "Project Page",
          path: "projectPage",
          type: "searchable",
          required: true,
          info: "Search and select project page",
          searchType: "projectPage",
        },
        {
          label: "Component Order",
          path: "componentOrder",
          type: "number",
          required: true,
          info: "Display order of this component",
        },
      ],
    },
    {
      label: "Record Type",
      path: "recordType",
      type: "select",
      options: recordTypeOptions,
      required: true,
    },
    { label: "Description", path: "description", type: "textarea" },

    ...resolveFieldsForCreate(form),
  ].filter(Boolean);
}

function resolveFieldsForCreate(form) {
  const recordType = form?.recordType;
  const buttonOneType = form?.buttonType;
  const buttonTwoType = form?.buttonType2;
  const buttonThreeType = form?.buttonType3;
  switch (recordType) {
    case "2 Column 50-50":
      return [
        {
          cols: 2,
          fields: [
            { label: "Headline 1", path: "headline1", type: "text" },
            { label: "Headline 2", path: "headline2", type: "text" },
          ],
        },

        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
        {
          label: "Image-Video Location 2",
          path: "imageLocation2",
          type: "file",
        },
        {
          cols: 2,
          fields: [
            {
              label: "Text Area 1",
              path: "textArea1",
              type: "textArea",
            },
            {
              label: "Text Area 2",
              path: "textArea2",
              type: "textArea",
            },
          ],
        },
        {
          label: "Button Type 1",
          path: "buttonType",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonOneType, 1, "")],
        },

        {
          label: "Button Type 2",
          path: "buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonTwoType, 2, "")],
        },
      ];
    case "2 Column Image Left 33-66":
      return [
        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 2",
              path: "headline2",
              type: "text",
            },
            {
              label: "Text Area 2",
              path: "textArea2",
              type: "text",
            },
          ],
        },
        {
          label: "Button Type 2",
          path: "buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonTwoType, 2, "")],
        },
      ];
    case "2 Column Image Left 50-50":
      return [
        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 2",
              path: "headline2",
              type: "text",
            },
            {
              label: "Text Area 2",
              path: "textArea2",
              type: "text",
            },
          ],
        },
        {
          label: "Button Type 2",
          path: "buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonTwoType, 2, "")],
        },
      ];
    case "2 Column Image Right 33-66":
      return [
        {
          label: "Image-Video Location 2",
          path: "imageLocation2",
          type: "file",
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 1",
              path: "headline1",
              type: "text",
            },
            {
              label: "Text Area 1",
              path: "textArea1",
              type: "text",
            },
          ],
        },
        {
          label: "Button Type 1",
          path: "buttonType",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonOneType, 1, "")],
        },
      ];
    case "2 Column Image Right 50-50":
      return [
        {
          label: "Image-Video Location 2",
          path: "imageLocation2",
          type: "file",
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 1",
              path: "headline1",
              type: "text",
            },
            {
              label: "Text Area 1",
              path: "textArea1",
              type: "text",
            },
          ],
        },
        {
          label: "Button Type 1",
          path: "buttonType",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonOneType, 1, "")],
        },
      ];
    case "3 Column 33-33-33":
      return [
        {
          cols: 2,
          fields: [
            {
              label: "Headline 1",
              path: "headline1",
              type: "text",
            },
            {
              label: "Text Area 1",
              path: "textArea1",
              type: "text",
            },
          ],
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 2",
              path: "headline2",
              type: "text",
            },
            {
              label: "Text Area 2",
              path: "textArea2",
              type: "text",
            },
          ],
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 3",
              path: "headline3",
              type: "text",
            },
            {
              label: "Text Area 3",
              path: "textArea3",
              type: "text",
            },
          ],
        },
        {
          label: "Button Type 1",
          path: "buttonType",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonOneType, 1, "")],
        },
        {
          label: "Button Type 2",
          path: "buttonType2",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_2,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonTwoType, 2, "")],
        },
        {
          label: "Button Type 3",
          path: "buttonType3",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_3,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonThreeType, 3, "")],
        },
        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
        {
          label: "Image-Video Location 2",
          path: "imageLocation2",
          type: "file",
        },
        {
          label: "Image-Video Location 3",
          path: "imageLocation3",
          type: "file",
        },
      ];
    case "Active Tasks":
      return [
        {
          cols: 2,
          fields: [
            {
              label: "Headline 1",
              path: "headline1",
              type: "text",
            },
            {
              label: "Text Area 1",
              path: "textArea1",
              type: "text",
            },
          ],
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 2",
              path: "headline2",
              type: "text",
            },
            {
              label: "Text Area 2",
              path: "textArea2",
              type: "text",
            },
          ],
        },
        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
      ];
    case "Splash Page":
      return [
        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 1",
              path: "headline1",
              type: "text",
            },
            {
              label: "Text Area 1",
              path: "textArea1",
              type: "text",
            },
          ],
        },
        {
          cols: 2,
          fields: [
            {
              label: "Headline 2",
              path: "headline2",
              type: "text",
            },
            {
              label: "Text Area 2",
              path: "textArea2",
              type: "text",
            },
          ],
        },
      ];
    case "Headline only":
      return [
        {
          label: "Headline 1",
          path: "headline1",
          type: "text",
        },
      ];
    case "Image Only":
      return [
        {
          label: "Image-Video Location 1",
          path: "imageLocation1",
          type: "file",
        },
      ];
    case "Standalone Button":
      return [
        {
          label: "Button Type 1",
          path: "buttonType",
          type: "select",
          picklistLabel: PPC_PICKLIST_LABELS.BUTTON_TYPE_1,
          required: true,
        },
        {
          cols: 2,
          fields: [...buildButtonDependentFields(buttonOneType, 1, "")],
        },
      ];
    case "Text Only Full Page":
      return [
        {
          label: "Text Area 1",
          path: "textArea1",
          type: "text",
        },
      ];
    default:
      return [];
  }
}
